export enum TooltipBox {
  CANCEL= 'tooltip_box_cancel'
}
